module.exports = __webpack_public_path__ + "static/media/neva-pharmacist.4de1d37c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/neva-pharmacist.png
// module id = 350
// module chunks = 0